/* eslint typescript-sort-keys/string-enum: "error" */

export enum SessionStorageKey {
  AuthorizationCapabilities = 'authorization_capabilities',
  BackOfficeIntegrationsPageNumber = 'backOffice_integrations.page_number',
  BackOfficeIntegrationsPageSize = 'backOffice_integrations.page_size',
  BackOfficeIntegrationsSearchTerm = 'backOffice_integrations.search_term',
  DealKanbanPipelineFilter = 'deals.kanbanPipelineId',
  InsightsCreatedByMeOverviewColumnOrder = 'insights_created_by_me_overview.column_order',
  InsightsCreatedByMeOverviewColumnPinning = 'insights_created_by_me_overview.column_pinning',
  InsightsCreatedByMeOverviewColumnSizing = 'insights_created_by_me_overview.column_sizing',
  InsightsCreatedByMeOverviewColumnVisibility = 'insights_created_by_me_overview.column_visibility',
  InsightsCreatedByMeOverviewPageNumber = 'insights_created_by_me_overview.page_number',
  InsightsCreatedByMeOverviewPageSize = 'insights_created_by_me_overview.page_size',
  InsightsCreatedByMeOverviewSorting = 'insights_created_by_me_overview.sorting',
  InsightsCreatedByMeOverviewTagsFilter = 'insights_created_by_me_overview.tags_filter',
  InsightsFavouritesOverviewColumnOrder = 'insights_favourites_overview.column_order',
  InsightsFavouritesOverviewColumnPinning = 'insights_favourites_overview.column_pinning',
  InsightsFavouritesOverviewColumnSizing = 'insights_favourites_overview.column_sizing',
  InsightsFavouritesOverviewColumnVisibility = 'insights_favourites_overview.column_visibility',
  InsightsFavouritesOverviewPageNumber = 'insights_favourites_overview.page_number',
  InsightsFavouritesOverviewPageSize = 'insights_favourites_overview.page_size',
  InsightsFavouritesOverviewSorting = 'insights_favourites_overview.sorting',
  InsightsFavouritesOverviewTagsFilter = 'insights_favourites_overview.tags_filter',
  InsightsReportsOverviewPageType = 'insights_reports_overview.page_type',
  InsightsSharedWithMeOverviewColumnOrder = 'insights_shared_with_me_overview.column_order',
  InsightsSharedWithMeOverviewColumnPinning = 'insights_shared_with_me_overview.column_pinning',
  InsightsSharedWithMeOverviewColumnSizing = 'insights_shared_with_me_overview.column_sizing',
  InsightsSharedWithMeOverviewColumnVisibility = 'insights_shared_with_me_overview.column_visibility',
  InsightsSharedWithMeOverviewPageNumber = 'insights_shared_with_me_overview.page_number',
  InsightsSharedWithMeOverviewPageSize = 'insights_shared_with_me_overview.page_size',
  InsightsSharedWithMeOverviewSorting = 'insights_shared_with_me_overview.sorting',
  InsightsSharedWithMeOverviewTagsFilter = 'insights_shared_with_me_overview.tags_filter',
  InvoicingCSVExportPeriod = 'invoicing_csv_export_period',
  InvoicingExcelExportPeriod = 'invoicing_excel_export_period',
  PlanningDate = 'planning_date',
  PlanningDateRange = 'planning_date_range',
  PlanningPlanTasksSearch = 'planning_plan_tasks_search',
  PlanningUserCollapsibles = 'planning_user_collapsibles',
  ProjectInvoicingEntityTypeFilter = 'project_invoicing_entity_type_filter',
  ProjectInvoicingStatusFilter = 'prroject_invoicing_status_filter',
  ProjectKanbanAssigneeFilter = 'project_kanban_assignee_filter',
  ProjectKanbanEntityTypeFilter = 'project_kanban_entity_type_filter',
  ProjectsInvoicesAdvancedFilters = 'projects_invoices_advanced_filters',
  ProjectsKanbanAdvancedFilters = 'projects_kanban_advanced_filters',
  ProjectsLastWBSLineType = 'projects_last_wbs_line_type',
  ProjectsOverviewFilters = 'projects_overview.filters',
  ProjectsOverviewPageNumber = 'projects_overview.page_number',
  ProjectsOverviewPageSize = 'projects_overview.page_size',
  ProjectsOverviewSortField = 'projects_overview.sort_field',
  ProjectsOverviewSortOrder = 'projects_overview.sort_order',
  ProjectsOverviewStatus = 'projects_overview.status',
  ProjectsOverviewTerm = 'projects_overview.term',
  ProjectsPreviewMode = 'projects_preview_mode',
  ProjectsTimelineExpandedProject = 'projects_timeline_expanded_project',
  ProjectsWbsAdvancedFilters = 'projects_wbs_advanced_filters',
  ProjectsWbsSorting = 'projects_wbs_sorting',
}

export const getPreferenceFromSessionStorage = <T = string>(key: string, defaultValue: T): T => {
  try {
    const foundValue = sessionStorage.getItem(`${key}`);
    if (foundValue === null) {
      return defaultValue;
    }

    return JSON.parse(foundValue);
  } catch {
    // sessionStorage not available or json could not be parsed.
    return defaultValue;
  }
};

export const savePreferenceToSessionStorage = <T = string>(key: string, value: T) => {
  try {
    sessionStorage.setItem(`${key}`, JSON.stringify(value));
  } catch {
    // sessionStorage not available or QuotaExceededError
  }
};
